import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreateMassiveChangeLayoutsInput,
    MassiveChangeLayouts,
    UpdateMassiveChangeLayoutsInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class MassiveChangeLayoutsService {
    private amplifyClient = generateClient();

    constructor() {}

    async getMassiveChangeLayout(id: string): Promise<MassiveChangeLayouts> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getMassiveChangeLayouts,
                    variables: {
                        id
                    }
                })
            ).data.getMassiveChangeLayouts;
            if (data) return data as MassiveChangeLayouts;
        } catch (error) {
            console.error('Error finding MassiveChangeLayouts:', error);
            return null;
        }
    }

    async listMassiveChangeLayouts(): Promise<MassiveChangeLayouts[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listMassiveChangeLayouts
                })
            ).data.listMassiveChangeLayouts.items;
            if (data) return data as MassiveChangeLayouts[];
        } catch (error) {
            console.error('Error finding MassiveChangeLayouts:', error);
            return null;
        }
    }

    async getLayoutByProviderId(
        providerId: string
    ): Promise<MassiveChangeLayouts[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.MassiveLayoutsByProvider,
                    variables: {
                        providerId
                    }
                })
            ).data.MassiveLayoutsByProvider.items;
            if (data) return data as MassiveChangeLayouts[];
        } catch (error) {
            console.error('Error finding MassiveChangeLayouts:', error);
            return null;
        }
    }

    async getLayoutByCreatorId(
        creatorId: string
    ): Promise<MassiveChangeLayouts[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.MassiveLayoutsByCreator,
                    variables: {
                        creatorId
                    }
                })
            ).data.MassiveLayoutsByCreator.items;
            if (data) return data as MassiveChangeLayouts[];
        } catch (error) {
            console.error(
                'Error finding MassiveChangeLayouts by creator:',
                error
            );
            return null;
        }
    }

    async createMassiveChangeLayouts(
        input: CreateMassiveChangeLayoutsInput
    ): Promise<MassiveChangeLayouts> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createMassiveChangeLayouts,
                    variables: {
                        input
                    }
                })
            ).data.createMassiveChangeLayouts;
            if (date) return date as MassiveChangeLayouts;
        } catch (error) {
            console.error('Error creating MassiveChangeLayouts:', error);
            return null;
        }
    }

    async updateMassiveChangeLayouts(
        input: UpdateMassiveChangeLayoutsInput
    ): Promise<MassiveChangeLayouts> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updateMassiveChangeLayouts,
                    variables: {
                        input
                    }
                })
            ).data.updateMassiveChangeLayouts;
            if (date) return date as MassiveChangeLayouts;
        } catch (error) {
            console.error('Error creating MassiveChangeLayouts:', error);
            return null;
        }
    }
}
